import { ShareItemProps } from '@/components/atoms/Share/Share.types'

export const ShareLinks = {
  facebook:
    'https://www.facebook.com/sharer/sharer.php?description={text}&u={url}',
  x: 'https://twitter.com/intent/tweet?text={text}&url={url}',
  telegram: 'https://t.me/share/url?text={text}&url={url}',
  linkedin: 'https://www.linkedin.com/shareArticle?mini=true&url={url}',
  email: 'mailto:?subject=NABA%20Competition&body={text}%20%20',
} as const

const NotLinkSharers = ['copy_to_clipboard']

const ShareIcons = {
  copy_to_clipboard: 'Share',
  facebook: 'Facebook',
  x: 'Twitter',
  telegram: 'Telegram',
  linkedin: 'Linkedin',
  email: 'Mail',
} as const

const getPlatformBaseLink = (id: keyof typeof ShareLinks, value: string) => {
  if (!ShareLinks[id]) return ''
  const link = ShareLinks[id]

  return link.replace('{text}', value)
}

const SharerModel = (data: { text: string; enabled_platforms: string[] }) => {
  const { text, enabled_platforms } = data
  const items = enabled_platforms.map((platform: string) => {
    const asLink = !NotLinkSharers.includes(platform)
    const href = asLink
      ? getPlatformBaseLink(platform as keyof typeof ShareLinks, text)
      : null

    const item: ShareItemProps = {
      id: platform as ShareItemProps['id'],
      icon: ShareIcons[platform as keyof typeof ShareIcons],
      title: platform,
      type: 'button',
    }

    if (asLink) {
      item.type = 'link'
      item.href = href as string
    }
    return item
  })

  return items
}

export default SharerModel
